"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
let HiddenArea = class HiddenArea extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.hiddenBlocks = [
            {
                blockLevel: 'Group',
                items: [
                    {
                        id: 0,
                        name: 'Group_1',
                        hidden: true
                    },
                    {
                        id: 1,
                        name: 'Group_2',
                        hidden: true
                    },
                    {
                        id: 1,
                        name: 'Group_3',
                        hidden: true
                    }
                ]
            },
            {
                blockLevel: 'Subgroup',
                items: [
                    {
                        id: 11,
                        name: 'Subgroup_11',
                        hidden: true
                    }
                ]
            },
            {
                blockLevel: 'Sample',
                items: [
                    {
                        id: 111,
                        name: '#00000C',
                        hidden: true
                    }
                ]
            }
        ];
        this.hiddenBlocksWithItems = this.hiddenBlocks.filter((b) => b.items.length > 0).map((bl) => bl);
    }
    showBlock(i) {
        let oldStatus = this.hiddenBlocks[i].items[0].hidden;
        this.hiddenBlocks[i].items.forEach((item) => item.hidden = !oldStatus);
    }
    showElement(i, j) {
        this.hiddenBlocks[i].items[j].hidden = !this.hiddenBlocks[i].items[j].hidden;
    }
    expand() {
        this.$emit('ontogglehidden', !this.options.expanded);
    }
    created() {
    }
    mounted() {
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], HiddenArea.prototype, "options", void 0);
HiddenArea = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            EyeOff: lucide_vue_next_1.EyeOff,
            Eye: lucide_vue_next_1.Eye,
            ChevronDown: lucide_vue_next_1.ChevronDown
        }
    })
], HiddenArea);
exports.default = HiddenArea;
